import { useState, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';

const API = process.env.REACT_APP_API_BASE_URL || '';

export function useHappyBusPackages() {
    const { authorizedFetch } = useAuth();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const request = useCallback(async (path, options = {}) => {
        const res = await authorizedFetch(`${API}/api/happy-bus-packages${path}`, options);
        if (!res.ok) {
            const body = await res.json().catch(() => ({}));
            throw new Error(body.error || `Error ${res.status}`);
        }
        return res.json();
    }, [authorizedFetch]);

    const fetchForDog = useCallback(async (dogId) => {
        setLoading(true); setError('');
        try {
            return await request(`?dogId=${dogId}`);
        } catch (err) {
            setError(err.message);
            return [];
        } finally {
            setLoading(false);
        }
    }, [request]);

    const create = useCallback(async (payload) => {
        return request('', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        });
    }, [request]);

    const addTrip = useCallback(async (pkgId, usedAt, notes = '', bookingRef = null) => {
        return request(`/${pkgId}/trip`, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ usedAt, notes, bookingRef }),
        });
    }, [request]);

    const removeTrip = useCallback(async (pkgId, sessionId) => {
        return request(`/${pkgId}/trip/${sessionId}`, { method: 'DELETE' });
    }, [request]);

    const remove = useCallback(async (pkgId) => {
        return request(`/${pkgId}`, { method: 'DELETE' });
    }, [request]);

    return { loading, error, fetchForDog, create, addTrip, removeTrip, remove };
}
